exports.deepCopy = function(obj) {
    if (obj !== undefined && obj !== null) {
        return JSON.parse(JSON.stringify(obj))
    }

    return null
}



// WEBPACK FOOTER //
// ./Src/Libs/Utils.js